import { Hidden, Paragraph } from 'applaus-ui-kit'
import { motion } from 'framer-motion'
import { ButtonBack } from '../../../../components/buttonBack/ButtonBack'
import { history } from '../../../../routes/services/history'
import * as S from './CookieDeclaration.styles'

export const CookieDeclaration = () => {
  return (
    <motion.div animate={{ opacity: [0, 1], transition: { duration: 0.5 } }}>
      <S.Container>
        <Hidden tablet desktop>
          <ButtonBack
            title="Declaração de cookies"
            click={() => history.push('/terms')}
          />
        </Hidden>

        <S.Wrapper>
          <S.Title>Declaração de cookies</S.Title>

          <Hidden tablet desktop>
            <Paragraph variant="small">
              A Applaus utiliza cookies e tecnologias semelhantes para garantir o funcionamento e a segurança da plataforma, manter a sessão do usuário, viabilizar recursos da compra e, mediante autorização, analisar a utilização dos nossos serviços e medir campanhas de publicidade.
            </Paragraph>
          </Hidden>

          <Hidden mobile>
            <Paragraph variant="small">
              A Applaus utiliza cookies e tecnologias semelhantes para garantir o funcionamento e a segurança da plataforma, manter a sessão do usuário, viabilizar recursos da compra e, mediante autorização, analisar a utilização dos nossos serviços e medir campanhas de publicidade.
            </Paragraph>
          </Hidden>
        </S.Wrapper>
      </S.Container>
    </motion.div>
  )
}
